import { PREFER_DIRECTS, STOPS } from '@web-platform/shared-universal-constants/src/queryParams';
import {
  DIRECT,
  ONE_STOP,
  TWO_PLUS_STOPS,
} from '@web-platform/shared-universal-constants/src/stops';
import { booleanKeyValuesParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import { INITIAL_STATE } from '../stops';

import type { StopsFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/stops';

const buildStopsState = (
  direct: boolean,
  oneStop: boolean,
  twoPlusStops: boolean,
): StopsFilterState => ({
  direct: { ...INITIAL_STATE.direct, value: direct },
  oneStop: { ...INITIAL_STATE.oneStop, value: oneStop },
  twoPlusStops: { ...INITIAL_STATE.twoPlusStops, value: twoPlusStops },
});

export const getStopsFromUrl = (): StopsFilterState => {
  const queryParams = parseParams();
  const stopsQueryParam = queryParams[STOPS];
  const preferDirectsParam = queryParams[PREFER_DIRECTS];

  if (!stopsQueryParam) {
    if (preferDirectsParam?.toLowerCase() === 'true') {
      return buildStopsState(true, false, false);
    }
    return INITIAL_STATE;
  }

  const parsedStopsParam = booleanKeyValuesParamParser
    .deserialize(stopsQueryParam)
    .reduce<Record<string, boolean>>((acc, { key, value }) => {
      acc[key.toLowerCase()] = value;
      return acc;
    }, {});

  const direct = parsedStopsParam[DIRECT.toLowerCase()];
  const oneStop = parsedStopsParam[ONE_STOP.toLowerCase()];
  const twoPlusStops = parsedStopsParam[TWO_PLUS_STOPS.toLowerCase()];

  return buildStopsState(
    direct === undefined ? true : direct,
    oneStop === undefined ? true : oneStop,
    twoPlusStops === undefined ? true : twoPlusStops,
  );
};
